export enum CHANGE_REQUEST_OVERRIDE_ACTION {
  OVERRIDE = 'override',
  SKIP = 'skip',
}
